import {gql} from '@apollo/client';
import {PodRiskReviewDetail} from '../types/PodRiskReviewType';
import {POD_RISK_REVIEW_ITEM_FIELDS} from './getPodRiskReviewPageList';

/**
 * 舆情 POD 审核详情（含 POD 图片预签名 URL 与操作日志）
 *
 * 图片 URL 有效期 10 分钟，按送检批次（requestId）锁定，不随订单新批次变化。
 */
export const GET_POD_RISK_REVIEW_DETAIL_BY_ID = gql`
    ${POD_RISK_REVIEW_ITEM_FIELDS}
    query GetPodRiskReviewDetailById($reviewTaskId: String!) {
        getPodRiskReviewDetailById(reviewTaskId: $reviewTaskId) {
            item {
                ...PodRiskReviewItemFields
            }
            podImages {
                url
                isRisky
            }
            logs {
                id
                action
                operatorId
                createdAt
                comment
            }
        }
    }
`;

export interface GetPodRiskReviewDetailByIdResponse {
    getPodRiskReviewDetailById?: PodRiskReviewDetail;
}

export interface GetPodRiskReviewDetailByIdInput {
    reviewTaskId: string;
}
